import { render, staticRenderFns } from "./DCI.vue?vue&type=template&id=0186f09e&scoped=true"
import script from "./DCI.vue?vue&type=script&lang=js"
export * from "./DCI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0186f09e",
  null
  
)

export default component.exports